import { BindingError } from "../../BindingError.js";
import { evaluateCondition } from "./evaluateCondition.js";
class FilterEvaluator {
  constructor(schema) {
    this.schema = schema;
  }
  evaluateFilter(entity, filter) {
    const entitySchema = this.schema.getEntity(entity.name);
    let acc = true;
    for (const [key, value] of Object.entries(filter)) {
      if (key === "and" || key === "or") {
        if (!Array.isArray(value)) {
          throw new BindingError();
        }
        const operation = key === "and" ? "every" : "some";
        acc && (acc = value[operation]((it) => this.evaluateFilter(entity, it)));
      } else if (key === "not") {
        acc && (acc = !this.evaluateFilter(entity, value));
      } else {
        const field = entitySchema.fields.get(key);
        if (!field) {
          throw new BindingError();
        }
        if (field.__typename === "_Column") {
          acc && (acc = evaluateCondition(entity.getField(key).value, value));
        } else {
          acc && (acc = this.evaluateFilter(entity.getEntity(key), value));
        }
      }
    }
    return acc;
  }
}
export {
  FilterEvaluator
};
//# sourceMappingURL=FilterEvaluator.js.map
